.options-table {
	margin: var(--mantine-spacing-md) 0;
}

.caption {
	margin: 0 0 var(--mantine-spacing-xs);
	font-size: var(--mantine-font-size-sm);
	font-weight: 600;
	color: var(--mantine-color-bright);
}

// The container carries `tabindex="0"`, so the focus ring is the only signal that a
// keyboard user has landed on the scrollable region.
.scroll-container {
	&:focus-visible {
		outline: 2px solid var(--docs-accent);
		outline-offset: 2px;
	}
}

.table {
	font-size: var(--mantine-font-size-sm);

	th,
	td {
		vertical-align: top;
		text-align: left;
	}

	thead th {
		background: var(--docs-card);

		@include light {
			background: var(--surreal-surface-light);
		}

		font-weight: 600;
		white-space: nowrap;
	}
}

.identity-cell {
	font-weight: 400;
}

.identity {
	display: flex;
	flex-wrap: wrap;
	align-items: baseline;
	gap: 0.4em;
}

.identity-name {
	font-family: var(--mantine-font-family-monospace);
	font-weight: 600;
	color: var(--mantine-color-bright);
}

.identity-value,
.mono,
.empty {
	color: var(--mantine-color-dimmed);

	@include light {
		color: var(--mantine-color-obsidian-5);
	}
}

.identity-value,
.mono {
	font-family: var(--mantine-font-family-monospace);
}

// Keep type, default and environment values on one line; the container scrolls instead.
td > .mono {
	white-space: nowrap;
}

// The kit's label outline is its violet; here it takes the product accent.
.required-label {
	align-self: center;
	flex-shrink: 0;
	border-color: var(--docs-accent) !important;
	color: var(--docs-accent-text) !important;
}

.empty {
	user-select: none;
}

.description {
	color: var(--mantine-color-text);
}
